const escape = (string) => {
  return (string || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
    .replace(/\u200b/g, '')
    .replace(/â€‹/g, '');
};

export default escape;
